import MonthlyReportingRowComponent from './monthly-reporting-row-component'

/***
 * An individual row within a MonthlyReportingGrid component. Can display an arbitrary number of metadata columns,
 * as well as 12 boxes (one for each month) to track report progress.
 */
const monthlyReportingRow = angular
    .module('FacilityData.MonthlyReporting.MonthlyReportingRow', [])
    .component('monthlyReportingRow', MonthlyReportingRowComponent)
    .name;

export default monthlyReportingRow;


// WEBPACK FOOTER //
// ./app/common/monthly-reporting/monthly-reporting-row/monthly-reporting-row.js